import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holidaycalendar-form',
  templateUrl: './holidaycalendar-form.component.html',
  styleUrls: ['./holidaycalendar-form.component.css']
})
export class HolidaycalendarFormComponent implements OnInit {

  title="Add Holiday";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/holidaycalendar/holidaycalendar-form/holidaycalendar-form.component.ts